import { inject } from "@ember/service"
import Component from "@glimmer/component"
import type { StandardSetSummary } from "@shared/models/csp-jurisdiction"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import { isString } from "lodash-es"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    jurisdictionId: string
    standardSet: StandardSetSummary
    changeSubject: (subject: string) => void
    changeStatus: (status: string) => void
    changeValidYear: (year: string) => void
    changeJurisdictionId: (id: string) => void
  }
}

export default class AdminCspStandardSetSummary extends Component<Signature> {
  @inject("ember-store") declare store: EmberStore
  @inject declare rpc: Rpc
  @tracked draftTitle: string | null = null
  @tracked isSaving: boolean = false
  @tracked isMenuOpen: boolean = false

  get isEditing() {
    return this.draftTitle && this.draftTitle !== this.args.standardSet.title
  }

  monitorKeys = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      this.changeTitle()
      // e.target.blur()
    } else if (e.key === "Escape") {
      this.cancelEditing()
      ;(e.target as HTMLElement).blur()
    }
  }

  toggleMenu = () => {
    this.isMenuOpen = !this.isMenuOpen
  }

  cancelEditing = () => {
    this.draftTitle = this.args.standardSet.title
  }

  get title() {
    return this.draftTitle ?? this.args.standardSet.title
  }

  changeTitle = () => {
    if (typeof this.draftTitle === "string") {
      this.isSaving = true
      this.rpc
        .admin_csp_edit_set({
          fieldMask: ["title"],
          standardSetIds: [this.args.standardSet.id],
          title: this.draftTitle,
        })
        .then((response) => {
          this.isSaving = false
          if (response.responseOk === false) {
            console.log(response)
            window.alert(`Sorry! There was an error! ${response.result.message}`)
          } else {
            this.store.find("standard-jurisdiction", this.args.jurisdictionId, true).then(() => {
              this.draftTitle = null
            })
          }
        })
    }
  }

  changeSubject = () => {
    let subject = window.prompt("Enter the new subject", this.args.standardSet.subject)
    if (isString(subject) === true && subject !== undefined && subject !== null) {
      this.args.changeSubject(subject)
    }
  }

  duplicateSet = () => {
    this.isSaving = true
    this.rpc
      .admin_csp_duplicate_set({
        standardSetId: this.args.standardSet.id,
      })
      .then((response) => {
        if (response.responseOk === false) {
          console.log(response)
          window.alert(`Sorry! There was an error! ${response.result.message}`)
        } else {
          this.store.find("standard-jurisdiction", this.args.jurisdictionId, true).then(() => {
            this.isSaving = false
          })
        }
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Admin::Csp::StandardSetSummary": typeof AdminCspStandardSetSummary
  }
}
